import { SettingService } from "./../services/setting.service";
import { Setting } from "./../models/setting";
import { MessageService } from "./../services/message.service";
import { Message } from "./../common/message";

import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material";
import { ConfirmDeleteDialogComponent } from "../dialog/confirm-delete-dialog/confirm-delete-dialog.component";

let ELEMENT_DATA = [];
@Component({
  selector: "app-setting",
  templateUrl: "./setting.component.html",
  styleUrls: ["./setting.component.scss"],
})
export class SettingComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = [
    "workhoursexceed",
    "callingdaysnumber",
    "motorDifferenceHours",
    "actions",
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  hideAdd: boolean = false;
  isAddNew: boolean = true;
  resource: any;

  constructor(
    private dialog: MatDialog,
    private service: SettingService,
    private formBuilder: FormBuilder,
    private msg: MessageService
  ) {}

  ngOnInit() {
    this.resource = new Setting();
    this.setMessageForm();
    this.getResources();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      workhoursexceed: ["", Validators.required],
      callingdaysnumber: ["", Validators.required],
      motorDifferenceHours: ["", Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll().subscribe((result) => {
      ELEMENT_DATA = ELEMENT_DATA.concat(result);
      if (ELEMENT_DATA && ELEMENT_DATA.length) {
        this.hideAdd = true;
      }
      this.updateDataSource();
    });
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.resource = new Setting();
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
  }

  onSave(
    workhoursexceed: HTMLDataElement,
    callingdaysnumber: HTMLDataElement,
    motorDifferenceHours: HTMLDataElement
  ) {
    this.submitted = true;

    if (this.form.controls.workhoursexceed.errors) {
      return;
    }

    if (this.form.controls.callingdaysnumber.errors) {
      return;
    }

    if (this.form.controls.motorDifferenceHours.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement(
        workhoursexceed,
        callingdaysnumber,
        motorDifferenceHours
      );
    } else {
      this.addElement(workhoursexceed, callingdaysnumber, motorDifferenceHours);
    }
  }

  resetForm(ret?: boolean) {
    this.hideAdd = true;
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement(workhoursexceed, callingdaysnumber, motorDifferenceHours) {
    this.resource.setWorkhoursexceed(workhoursexceed.value);
    this.resource.setCallingdaysnumber(callingdaysnumber.value);
    this.resource.setMotorDifferenceHours(motorDifferenceHours.value);

    this.service.create(this.resource).subscribe((result) => {
      this.msg.alert(Message.SAVE);
      ELEMENT_DATA.push(result);
      this.updateDataSource();
      this.resource = new Setting();
      this.resetForm(true);
    });
  }

  updateElement(workhoursexceed, callingdaysnumber, motorDifferenceHours) {
    this.resource.setWorkhoursexceed(workhoursexceed.value);
    this.resource.setCallingdaysnumber(callingdaysnumber.value);
    this.resource.setMotorDifferenceHours(motorDifferenceHours.value);
    this.service.update(this.resource).subscribe((result) => {
      this.msg.alert(Message.UPDATE);
      ELEMENT_DATA.forEach((elem, index) => {
        if (elem.id === this.resource.id) {
          ELEMENT_DATA.splice(index, 1, result);
          return;
        }
      });

      this.updateDataSource();
      this.resource = new Setting();
      this.resetForm(true);
    });
  }

  editElement(ele) {
    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource = ele;
    this.resource = new Setting();

    this.resource.setId(ele.id);
    this.resource.setWorkhoursexceed(ele.workhoursexceed);
    this.resource.setCallingdaysnumber(ele.callingdaysnumber);
    this.resource.setMotorDifferenceHours(ele.motorDifferenceHours);

    this.form.controls.workhoursexceed.setValue(ele.workhoursexceed);
    this.form.controls.callingdaysnumber.setValue(ele.callingdaysnumber);
    this.form.controls.motorDifferenceHours.setValue(ele.motorDifferenceHours);
  }
}
